import { Box, styled, Typography } from '@mui/material';

export const SummaryContainer = styled(Box)(({ theme }) => ({
  borderBottom: `solid 1px ${theme.palette.colors.scrollOnPrimaryBackground}`,
  paddingBottom: '12px',

  [theme.breakpoints.up('lg')]: {
    marginBottom: '15px',
  },
}));

export const DateLabel = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginBottom: '3px',

  [theme.breakpoints.up('lg')]: {
    fontSize: '10px',
  },
}));

export const InlineElements = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));

export const ContentText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  lineClamp: 3,
  WebkitBoxOrient: 'vertical',

  [theme.breakpoints.up('lg')]: {
    fontSize: '12px',
    WebkitLineClamp: 2,
    lineClamp: 2,
  },
}));
